module.exports = __webpack_public_path__ + "static/media/qr-code-whatsapp.bcc8db98.svg";